import React, { memo } from 'react';
import { EventsRegistry } from "../../../engine/events/index";


const TableHeaderFilter = memo(({ 
  columns, tableId,
  col, 
  unitIndex, 
  currentUnit,
  filters, 
  updateContext,
}) => {
  const path = `context_units.${unitIndex}.view.filters.${col.name}`;

  // DELETE: Filters out items marked as selected in metadata
  const handleDeleteSelected = () => {
    const selectedCount = currentUnit.data.filter(item => item.meta?.selected).length;
    
    if (!selectedCount || !window.confirm(`Are you sure you want to delete ${selectedCount} rows?`)) {
      return;
    }

    const updatedData = currentUnit.data.filter(item => !item.meta?.selected);
    const dataPath = `context_units.${unitIndex}.data`;
    updateContext(dataPath, updatedData);
  };

  // ADD: Appends a blank row with a unique ID
  const handleAddNewRow = () => {
    const newRow = {
      row_id: `new-${Date.now()}`, // Unique temporary ID
      row: {}, // Empty data object
      meta: { selected: false }
    };
    
    const updatedData = [...currentUnit.data, newRow];
    updateContext(`context_units.${unitIndex}.data`, updatedData);
  };

  // EXPORT: Simple CSV generator
  const handleExportToCSV = () => {
    const selectedData = currentUnit.data.filter(item => item.meta?.selected);
    const dataToExport = selectedData.length ? selectedData : currentUnit.data;
    
    const csvContent = "data:text/csv;charset=utf-8," 
      + columns.map(c => c.name).join(",") + "\n"
      + dataToExport.map(item => columns.map(c => item.row[c.name] || "").join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${tableId}_export.csv`);
    document.body.appendChild(link);
    link.click();
  };



  if (col.name === "Actions") {
    return (
      <select 
        className="header-filter-select"
        style={{ fontWeight: 'bold', color: '#007bff' }}
        onChange={(e) => {
          const action = e.target.value;
          if (!action) return;
          if (action === "remove") handleDeleteSelected();
          if (action === "export") handleExportToCSV();
          if (action === "add") handleAddNewRow();
          e.target.value = "";
        }}
      >
        <option value="">⚡ Actions</option>
        <option value="add">➕ Add New Row</option>
        <option value="remove">🗑️ Delete Selected</option>
        <option value="export">📥 Export Selected</option>
      </select>
    );
  }

  let displayValue = filters[col.name] || "";
  if (typeof displayValue === 'object' && displayValue !== null) {
    displayValue = displayValue.value || displayValue.label || JSON.stringify(displayValue);
  }

  if (col.type === "select" || col.filterType === "dropdown") {
    return (
      <select
        className="header-filter-select"
        value={displayValue} 
        onChange={(e) => updateContext(path, e.target.value)}
      >
        <option value="">All {col.name}</option>
        {col.options?.map(opt => {
          const optLabel = typeof opt === 'object' ? opt.label : opt;
          const optValue = typeof opt === 'object' ? opt.value : opt;
          return <option key={optValue} value={optValue}>{optLabel}</option>;
        })}
      </select>
    );
  }

  return (
    <input
      className="header-filter-input"
      placeholder={`Filter...`}
      value={displayValue} 
      onChange={(e) => updateContext(path, e.target.value)}
    />
  );
}, (prev, next) => {
  // PERFORMANCE: Only re-render if the specific filter for this column changed
  return prev.filters[prev.col.name] === next.filters[next.col.name];
});

export default TableHeaderFilter;
